exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p {\n  color: #60b515;\n  font-weight: bold;\n  float: right;\n  margin: 0 0 0 auto; }\n\n.adjust p {\n  color: #565656; }\n\n.discr {\n  color: #c92100; }\n\n.term-diff, .adjust {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center; }\n\n.delete-col {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center; }\n\n.invalid-tip {\n  pointer-events: none;\n  color: #ebafa6 !important;\n  position: absolute !important;\n  top: 0;\n  padding-left: 12px;\n  font-size: 12px; }\n\n.ng-invalid:not(.ng-pristine) {\n  border-color: #ebafa6 !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/views/daily-recon/eod-recon/components/deposits-eod-container/form-deposits-speedpoint/form-deposits-speedpoint-row/form-deposits-speedpoint-row.component.scss
// module id = ../../../../../src/app/views/daily-recon/eod-recon/components/deposits-eod-container/form-deposits-speedpoint/form-deposits-speedpoint-row/form-deposits-speedpoint-row.component.scss
// module chunks = main